module.exports = __webpack_public_path__ + "img/TK.18169e46.svg";